module.exports = __webpack_public_path__ + "img/34.8.TSS.e8d110e6.png";